import React, { useState, useEffect } from 'react'
import { Map } from 'immutable'
import PropTypes from 'prop-types'
import _isArray from 'lodash/isArray'
import _parseInt from 'lodash/parseInt'

export const FORMAT_DAYS_HRS_MINS = 'days_hrs_mins'
export const FORMAT_HH_MM_SS = 'hh:mm:ss'
export const FORMAT_SS = 'ss'

function getFormattedTimer (durationMs, format, isReady, staticText) {
  if (!isReady) {
    return '00:00:00'
  }

  const days = _parseInt(Math.floor((durationMs / 1000 / 60 / 60 / 24)))
  const hours = format === FORMAT_DAYS_HRS_MINS
    ? _parseInt(Math.floor((durationMs / 1000 / 60 / 60) % 24))
    : _parseInt(Math.floor((durationMs / 1000 / 60 / 60)))
  const minutes = _parseInt(Math.floor((durationMs / 1000 / 60) % 60))
  const seconds = format === FORMAT_SS
    ? _parseInt(Math.floor((durationMs / 1000)))
    : _parseInt(Math.floor((durationMs / 1000) % 60))

  if (format === FORMAT_HH_MM_SS) {
    const formatHours = (hours < 10 ? '0' : '') + hours
    const formatMinutes = (minutes < 10 ? '0' : '') + minutes
    const formatSeconds = (seconds < 10 ? '0' : '') + seconds
    return `${formatHours}:${formatMinutes}:${formatSeconds}`
  }

  if (format === FORMAT_DAYS_HRS_MINS) {
    const daysLabel = (days === 1) ? staticText.get('day') : staticText.get('days')
    const hoursLabel = (hours === 1) ? staticText.get('hour') : staticText.get('hours')
    const minutesLabel = (minutes === 1) ? staticText.get('minute') : staticText.get('minutes')
    return `${days} ${daysLabel} ${hours} ${hoursLabel} ${minutes} ${minutesLabel}`
  }

  return seconds
}

function CountdownTimer ({
  timerClass,
  durationMs,
  format,
  staticText = Map(),
}) {
  const [isReady, setReady] = useState(false)
  const [duration, setDuration] = useState(durationMs)
  const itemClass = _isArray(timerClass) ? timerClass.join(' ') : ''

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDuration(duration - 1000 > 0 ? duration - 1000 : 0)
    }, 1000)

    if (!isReady) {
      setReady(true)
    }

    return () => {
      clearTimeout(timeout)
    }
  })

  return (
    <span className={`countdown-timer ${itemClass}`}>
      {getFormattedTimer(duration, format, isReady, staticText)}
    </span>
  )
}

CountdownTimer.defaultProps = {
  durationMs: 0,
  format: FORMAT_HH_MM_SS,
}

CountdownTimer.propTypes = {
  timerClass: PropTypes.array,
  durationMs: PropTypes.number.isRequired,
  format: PropTypes.string,
}

export default CountdownTimer
